import React from "react";

import { ButtonWithRouter, ButtonWithIcon } from "./ButtonWithIcon";
import { LexWorkplaceCheckIcon, LexWorkplaceXIcon } from "./LexWorkplaceIcons";
import "./TwoColumnWrapper.css";

//wrapper for a form component
function TwoColumnWrapper(props) {
	return (
		<div className="noDefaultMargin" style={{ margin: "0 30px 30px 30px" }}>
			<div
				style={{
					height: 64,
					lineHeight: "64px",
					display: "flex",
					flexDirection: "row",
					justifyContent: "space-between",
					gap: 8,
				}}
			>
				<div style={{ minWidth: "fit-content" }}>
					{props.iconComponent ? props.iconComponent : null}
					<span
						style={{
							fontFamily: "MainFont-SemiBold",
							fontSize: 16,
							marginLeft: 8,
						}}
					>
						{props.headingText}
					</span>
				</div>
				{props.rightHeading ? <div>{props.rightHeading}</div> : null}
			</div>
			<div
				style={{
					backgroundColor: "var(--lw-light-grey-a)",
					padding: 30,
					...(props.maxContentWidth
						? { maxWidth: props.maxContentWidth }
						: {}),
				}}
			>
				<div
					style={{
						display: "grid",
						gridTemplateColumns: "1fr 1fr",
						gridGap: 50,
					}}
				>
					<div
						style={{ maxWidth: "45vw" }}
						className="twoColumnWrapperColumn"
					>
						{props.leftChildren}
					</div>
					<div
						style={{ maxWidth: "45vw" }}
						className="twoColumnWrapperColumn"
					>
						{props.rightChildren}
					</div>
				</div>
				<div
					style={{
						display: "flex",
						justifyContent: "flex-end",
					}}
				>
					<ButtonWithRouter
						type="go-back"
						defaultGoBackLocation={props.defaultGoBackLocation}
						buttonText={props.cancelButtonText || "Cancel"}
						iconComponent={<LexWorkplaceXIcon />}
						style={{ marginRight: 8 }}
					/>
					<ButtonWithIcon
						handler={() => {
							props.canSubmit && props.submit();
						}}
						disabledHoverText={props.submitDisabledHoverText}
						buttonText={props.submitButtonText}
						className="blue"
						disabled={!props.canSubmit}
						iconComponent={<LexWorkplaceCheckIcon />}
					/>
				</div>
			</div>
		</div>
	);
}

export default TwoColumnWrapper;
